/**
 * Models a user's account object
 */

import GenericModel from "./generic/model";
import AccountData from "./account-data";
import environment from "../common/environment";

const Model = GenericModel.extend({
  urlRoot: environment.getEndpoint("users"),
  namedAttributes: {
    id: Number,
    data: AccountData,
  },
  initialize() {
    this.promise = this.fetch();
  },

  // convenience methods
  getFirstInitial() {
    const data = this.getData();
    return `${data.getFirstName().substring(0, 1)}.`;
  },
  getAbbreviatedName() {
    const data = this.getData();
    return `${this.getFirstInitial()} ${data.getLastName()}`;
  },
  getFullName() {
    const data = this.getData();
    return `${data.getFirstName()} ${data.getLastName()}`;
  },
  hasRole(role) {
    const roles = this.getRoles();
    return roles && roles.findWhere({ key: role }) ? true : false;
  },
  setRoles(coll) {
    this.getData().setRoles(coll);
  },
  getRoles() {
    return this.getData().getRoles();
  },
  getRole(key) {
    const roles = this.getRoles();
    return roles ? this.getRoles().findWhere({ key }) : null;
  },
  getRoleById(id) {
    const roles = this.getRoles();
    return roles ? this.getRoles().findWhere({ id }) : null;
  },
});

export { Model as default };
